import type { Flag } from './records/Flag';
import { createRollout } from './records/Rollout';
import type { Rule } from './records/Rule';
import type { Variation } from './records/Variation';

export function setRolloutForRule(rule: Rule, flag: Flag, variation: Variation, weight: number, contextKind?: string) {
  const variations = flag.getVariations();
  const variationIndex = variations.findIndex((v) => v._key === variation._key);
  if (variationIndex === -1) {
    return rule;
  }

  return (
    rule
      .delete('variation')
      .update('rollout', (r) => (r && !r.experimentAllocation ? r : createRollout({ contextKind })))
      // We can safely assert the rollout exists here because we created it above
      // oxlint-disable-next-line no-non-null-assertion
      .update('rollout', (r) => r!.setWeightForVariation(flag, variation, weight))
  );
}
